import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    components: {
        MuiButton: {
            variants: [
                {
                    props: { variant: "text" },
                    style: {
                        fontSize: 12,
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                    },
                },
            ],
        },
    }
});

theme.typography.h2 = {
    fontSize: 16,
    fontWeight: 500,
    color: "#333",
    lineHeight: "20px",
    marginBottom: "30px",
};

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:
            theme.palette.grey[
            theme.palette.mode === "light" && "#F6FBFF"
            ],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === "light" && "#44A4EB",
    },
}));